import React from "react";
import { TextField } from "../../../../components/TextField";
import styled from "@emotion/styled";

const Observacao = ({ classes, onChangeObservacao, observacao, disabled }) => {

    const styles = {
        inputRoot: {
            maxHeight: "400px",
            overflowY: "scroll",
        },
    };

    return (
        <ContentCardObservacao>
            <Label> Observação</Label>
            <TextField
                value={observacao}
                onChange={(e) => onChangeObservacao(e)}
                InputProps={{
                    style: styles.inputRoot,
                }}
                style={styles.root}
                maxLength={500}
                multiline
                disabled={disabled}
            >
            </TextField>

        </ContentCardObservacao>
    )
}

const ContentCardObservacao = styled.div`
display: flex;
  flex-direction: ${({ direction }) => direction};
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 16px;

  @media(max-width: 760px) {
    &> div {
      width: 100%;
    }
  }
`
const Label = styled.div`
  display:flex;
  flex-direction: row;
  gap: 4px;
  font-weight: 700;
  font-size: 18px;
}`

export default Observacao;